import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "../Styles/Components/Header.css";

import ContactPopup from "./Popup";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopupOpen: false,
      isMobileMenuOpen: false,
      isMobile: false,
    };
  }

  openPopup = (e) => {
    e.preventDefault();
    this.setState({ isPopupOpen: true });
  };

  closePopup = () => {
    this.setState({ isPopupOpen: false });
  };

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
    }));
  };

  closeMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false });
  };

  checkIfMobile = () => {
    const isMobile = window.innerWidth <= 767;
    this.setState({ isMobile });
  };

  componentDidMount() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
    document.body.addEventListener("click", this.handleOutsideClick);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkIfMobile);
    document.body.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick = (e) => {
    // Menü açıkken header dışında bir yere tıklandığında menüyü kapat
    if (
      this.state.isMobileMenuOpen &&
      !e.target.closest(".header-area") &&
      !e.target.closest(".menu-trigger")
    ) {
      this.setState({ isMobileMenuOpen: false });
    }
  };

  render() {
    const { isPopupOpen, isMobileMenuOpen } = this.state;

    return (
      <>
        <header className="header-area">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <nav className="main-nav">
                  <a href="/" className="logo">
                    <img
                      src="./Assets/Images/rba.png"
                      alt=""
                      id="header-logo-img"
                    />
                  </a>
                  <ul className="nav">
                    <li>
                      <NavLink to="/" exact activeclassname="active">
                        Ana Sayfa
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/ilanlar" activeclassname="active">
                        İlanlar
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/iletisim" activeclassname="active">
                        İletişim
                      </NavLink>
                    </li>
                    <li>
                      <a href="#" onClick={this.openPopup}>
                        <i className="fa fas fa-handshake"></i> RBA ile Al Sat
                        Kirala
                      </a>
                    </li>
                  </ul>
                  <a
                    className={`menu-trigger ${
                      isMobileMenuOpen ? "active" : ""
                    }`}
                    onClick={this.toggleMobileMenu}
                  >
                    <span>Menu</span>
                  </a>
                </nav>
              </div>
            </div>
          </div>

          {/* Mobil Menü */}
          <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
            <ul className="mobile-nav">
              <li>
                <NavLink
                  to="/"
                  exact
                  activeclassname="active"
                  onClick={this.closeMobileMenu}
                >
                  Ana Sayfa
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/ilanlar"
                  activeclassname="active"
                  onClick={this.closeMobileMenu}
                >
                  İlanlar
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/iletisim"
                  activeclassname="active"
                  onClick={this.closeMobileMenu}
                >
                  İletişim
                </NavLink>
              </li>
              {/* <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.closeMobileMenu();
                    this.openPopup();
                  }}
                >
                  <i className="fa fas fa-handshake"></i> RBA ile Al Sat Kirala
                </a>
              </li> */}
            </ul>
          </div>
        </header>

        {/* Popup bileşeni */}
        <ContactPopup isOpen={isPopupOpen} onClose={this.closePopup} />
      </>
    );
  }
}
